import React from "react";
import styles from "./About.module.css";
import { WHATSAPP_LINK } from "../siteData";

export default function About() {
  return (
    <section id="about" className={styles.section}>
      <div className={`container ${styles.grid}`}>
        <div className={styles.panel}>
          <p className={styles.panelEyebrow}>Since day one</p>
          <p className={styles.panelStat}>Homes · Offices · Shops</p>
          <p className={styles.panelNote}>
            Properties we've cleaned and renovated across every job type.
          </p>
        </div>

        <div className={styles.copy}>
          <p className="jc-eyebrow">About Us</p>
          <h2 className={styles.title}>
            Built on reliable work and straightforward service
          </h2>
          <p className={styles.lead}>
            Jia Cheng Cleaning &amp; Renovation provides reliable and
            professional cleaning and renovation services for homes, offices,
            shops and other properties. We handle general cleaning, deep
            cleaning, post-renovation cleaning, plumbing, electrical work,
            painting, kitchen and bathroom renovation, installation, repair,
            and all kinds of renovation and maintenance work.
          </p>
          <p className={styles.lead}>
            Our goal is simple: quality workmanship, reasonable prices, and
            dependable service for every customer, every time.
          </p>

          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className={`jc-btn jc-btn-dark ${styles.cta}`}
          >
            Get a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
}
